import { formatPhoneNumberIntl } from 'react-phone-number-input';

export function formatPhone(phone: string | undefined | null) {
  if (!phone) return '';
  return formatPhoneNumberIntl(phone.replace(/^([^\D])/g, '+$1'));
}
